module.exports = __webpack_public_path__ + "img/customer.0c67bfcf.svg";